import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CategoryBarsSettingsStateType, defaultSettings } from "./CategoryBarsSettings";
import TitleCase from "components/formatting/TitleCase";
import ISOPercentage from "components/formatting/ISOPercentage";
import ISONumber from "components/formatting/ISONumber";

interface CategoryBarPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: CategoryBarsSettingsStateType | {};
}

export default function CategoryBarsPreview(props: CategoryBarPreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const windowHeight = window.innerHeight;
  const chartColors = theme.colors.namedColors.chartColorArray;
  const currentState = {...defaultSettings, ...props.settingsState};

  const dummyData = [
    { label: '1', percent: .90, color: chartColors[0] },
    { label: '2', percent: .80, color: chartColors[0] },
    { label: '3', percent: .75, color: chartColors[0] },
    { label: '4', percent: .65, color: chartColors[0] },
    { label: '5', percent: .50, color: chartColors[0] },
    { label: '6', percent: .35, color: chartColors[0] },
    { label: '7', percent: .25, color: chartColors[0] }
  ];

  const dummyRows = dummyData.map((row, index) => {
    return (
      <Box key={row.label}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="subtitle2">
            <TitleCase text={row.label} />
          </Typography>
          <Box sx={{ ml: 1}}>
            {currentState.displayValue === "percent" && <ISOPercentage value={row.percent} />}
            {currentState.displayValue === "count" && <ISONumber number={Math.round(row.percent * 100)} />}
          </Box>
        </Box>
        <Box
          sx={{
            mb: 2,
            width: "100%",
            height: "25px",
            backgroundColor: theme.palette.grey[300]
          }}>
          <Box sx={{ width: `${row.percent * 100}%`, height: "100%", backgroundColor: row.color }} />  
        </Box>
      </Box>
    );
  })

  return (
    <Stack
      sx={{
        gap: 1,
        width: isSmallScreen ? "100%" : "50%",
        flex: 1,
        height: windowHeight < 600 ? "35vh" : "55vh"
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle} />
        </Typography>}
      <Box>{dummyRows}</Box>
    </Stack>
  );
}